import cn from 'classnames';
import { memo, type FC } from 'react';
import { useDescriptionEditorValueHandler } from '@widgets/shared/Forms/DescriptionEditor/useDescriptionValueHandler.ts';
import { ViewerNoteEditorContent } from '@shared/ui';
import * as formDescriptionEditorStyles from '@src/widgets/shared/Forms/DescriptionEditor/styles.module.scss';
import st from './styles.module.scss';

interface Props {
  noteDescription: string;
  withAuthorName: boolean;
}

export const NoteBody: FC<Props> = memo(({ noteDescription, withAuthorName }) => {
  const { isImgGoingAfterText, isImgFirst } = useDescriptionEditorValueHandler({
    value: noteDescription,
  });
  return (
    <div className={cn(st.card, withAuthorName && st.withAuthorName)}>
      <ViewerNoteEditorContent
        htmlString={noteDescription}
        wrapperClassName={st.wrapperClassName}
        className={cn(
          st.noteBody,
          isImgGoingAfterText && formDescriptionEditorStyles.imgGoingAfterText,
          isImgFirst && formDescriptionEditorStyles.imgFirst
        )}
        type="formField"
      />
    </div>
  );
});
